import { useMemo } from "react";
import { useServices } from "contexts/ServiceContext";

const spanishSpeakingCountries = ["AR", "CO", "CL", "EC", "ES", "MX", "PE"];

export const useShouldShowBanner = () => {
    const services = useServices();

    const shouldShowBanner = useMemo(
        () => spanishSpeakingCountries.includes(services.Configs.country_code.toUpperCase()),
        [services.Configs.country_code],
    );

    return shouldShowBanner;
};
